import { from, of } from 'rxjs';
import { catchError, filter, map, mergeMap, retry } from 'rxjs/operators';
import { deviceListInit } from 'store/Device/Device.actions';
import { isActionOf, RootEpic } from 'typesafe-actions';
import { getReachableClientsAsync } from './ReachableClient.actions';

const RETRY_COUNT = 3;

export const toGetReachableClientsReq: RootEpic = (action$, _store$, { api }) =>
  action$.pipe(
    filter(isActionOf(getReachableClientsAsync.request)),
    mergeMap(() =>
      from(api.client.getReachableClients()).pipe(
        retry(RETRY_COUNT),
        map(getReachableClientsAsync.success),
        catchError((err) => of(getReachableClientsAsync.failure(String(err)))),
      ),
    ),
  );

/**
 * @description Load the reachable clients once when the device page mounts.
 * Skipped if the list is already populated so we do not refetch on every navigation.
 */
export const onDeviceListInit: RootEpic = (action$, store$) =>
  action$.pipe(
    filter(isActionOf(deviceListInit)),
    filter(() => store$.value.reachableClient.items.length === 0),
    map(() => getReachableClientsAsync.request()),
  );
